import { StatusScreen } from "@mercadopago/sdk-react";
import { useEffect } from "react";


const StatusUpdate = (props) => {
    const {preferenceID} = props;;
  
  async function checkPaymenteInRealTime() {
    const intervalId = setInterval(async () => {
      try {
        const response = await fetch(`https://arbitragem.bet:3131/payment/query_transation/${preferenceID}/`);
        const data = await response.json();
  
        if ("status" in data && data["status"] === true) {
          clearInterval(intervalId);
          window.location.href = "/payment-approved";
        }
      } catch (error) {
        console.error("Erro ao verificar pagamento:", error);
      }
    }, 10000);
  }

  useEffect(()=>{
    checkPaymenteInRealTime();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])
  
  let x = {"paymentId": preferenceID}
  return (
    <section>
  
      <StatusScreen
        initialization={x}
      />
    </section>
  );
};

export default StatusUpdate;
